import React, { Component } from 'react';
import { connect } from 'react-redux';


import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import appStyles from '../../App/app.module.css';
import passwordStyles from './changePasswordStyles.module.css';
import menuIcon from '../../assets/FD_Logo.png';
import { Check, Clear } from '@material-ui/icons';
import LockIcon from '@material-ui/icons/Lock';
import PhoneIcon from '@material-ui/icons/Phone';
import userManagementReqHandler from '../../api/userManagementRemote';
import ResponseError from '../../models/ResponseError';

import { receiveError } from '../../store/actions/notificationAction';
import { fetchFinish, fetchPending } from '../../store/actions/fetchingAction';
import { logoutAction } from '../../store/actions/loginAction';
import { InputAdornment } from '@material-ui/core';

const styles = (theme: any) => createStyles({
  textField: {
    margin: '10px 0'
  },
  button: {
    margin: theme.spacing.unit,
    marginBottom: '30px'
  },
});


 

interface ChangePasswordContainerProps extends WithStyles<typeof styles> {
  receiveError: Function;
  fetchFinish: Function;
  fetchPending: Function;
  logout: Function;
};

interface ChangePasswordContainerState {
  input: {
    password: string;
    password2: string;
    phone: string;
  }
};

const PREFIX_PHONE_NUMBER: string = "+1";

class ChangePasswordContainer extends Component<ChangePasswordContainerProps, ChangePasswordContainerState> {

  state = {
    input: {
      password: '',
      password2: '',
      phone: '',
    }
  }

  changePassword = (e: any) => {
    e.preventDefault();

    this.props.fetchPending();
    userManagementReqHandler.changePassword(this.state.input.password, this.state.input.password2, 
        PREFIX_PHONE_NUMBER + this.state.input.phone).then(resp => {
      this.props.fetchFinish();
      const success = resp.success;
      const error: ResponseError | undefined = resp.error;

      if (error) {
        this.props.receiveError(error);
      }

      if(success) {
        this.props.logout();
      }
    })
  }

  verifyPhone = (phone: string) => {
    const telRegex = RegExp(/^\+(.*\d.*){10,}$/);
    if(!telRegex.test(PREFIX_PHONE_NUMBER + phone)){
      return false;
    }
    return true;
  }

  onFieldChange = (event: any, value?: string) => {
    let inputState: any = {...this.state.input};
    inputState[event.target.name] = event.target.value;
    this.setState({ input: inputState });
  }

  passwordValidation = (password: string) => {
    let atLeast8CharPassword = password.length >= 8;
    let atLeast1Number = false, atLeastOneSymbol = false, atLeastOneUpperCase = false;

    for (let i = 0; i < password.length; i++) {
      let c = password[i];
      if (c >= '0' && c <= '9')
        atLeast1Number = true;
      if (c >= 'A' && c <= 'Z')
        atLeastOneUpperCase = true;

      let specialChars: string = "!@#_";
      if (specialChars.indexOf(c) != -1)
        atLeastOneSymbol = true;
    }

    let allTypesCharsPassword = atLeast1Number && atLeastOneSymbol && atLeastOneUpperCase;

    return { atLeast8CharPassword, allTypesCharsPassword };
  }

  render() {
    let {atLeast8CharPassword, allTypesCharsPassword} = this.passwordValidation(this.state.input.password)
    let validPhone = this.verifyPhone(this.state.input.phone) || this.state.input.phone === '';
    let samePasswords = this.state.input.password === this.state.input.password2;
    return (
      <div className={`${passwordStyles.loginRow} ${passwordStyles.CpContainer}`}>
        <div className={ passwordStyles.loginRow }>
          <img alt="logo" src={ menuIcon } className={passwordStyles.logoImg} />
          <h1 className={ passwordStyles.loginHeader }>Welcome to TRYPOD</h1>
        </div>

        <div className={passwordStyles.loginRow}>
          <div className={passwordStyles.loginCol}>

            <form className={appStyles.col} onSubmit={this.changePassword}>
              <div className={passwordStyles.passwordDescription}>
                <p><b>This is your first login and you must change your default password </b></p>
              </div>

              <FormControl>
                <TextField
                  id="outlined-password"
                  name='password'
                  type="password"
                  label=""
                  className={this.props.classes.textField}
                  value={this.state.input.password}
                  onChange={this.onFieldChange}
                  error={this.state.input.password === ''}
                  required
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockIcon color="primary" className={ passwordStyles.materialIcon }/>
                      </InputAdornment>
                    ),
                    classes: { input: passwordStyles.loginInput }
                  }}
                  placeholder="Password"                
                />
                <TextField
                  id="outlined-password2"
                  name='password2'
                  type="password"
                  label=""
                  className={this.props.classes.textField}
                  value={this.state.input.password2}
                  onChange={this.onFieldChange}
                  error={!samePasswords}
                  required
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockIcon color="primary" className={ passwordStyles.materialIcon }/>
                      </InputAdornment>
                    ),
                    classes: { input: passwordStyles.loginInput }
                  }}
                  placeholder="Confirm password"                
                />
                <TextField
                  id="outlined-tel"
                  label=""
                  name='phone'
                  className={this.props.classes.textField}
                  value={this.state.input.phone}
                  onChange={this.onFieldChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start" >
                        <PhoneIcon color="primary" className={ passwordStyles.materialIcon }/>
                        { PREFIX_PHONE_NUMBER }
                      </InputAdornment>
                    ),
                    classes: { input: passwordStyles.loginInput }
                  }}
                  placeholder="Phone number(optional)"
                />
                <Button type="submit" color="primary" disabled={!validPhone || !samePasswords} variant="contained" className={this.props.classes.button} >Change password</Button>
              </FormControl>

              <div className={passwordStyles.passwordPolicyContainer}>
                <div className={passwordStyles.passwordPolicyHeader}>
                    Password Policy:
                </div>
                <div className={passwordStyles.passwordPolicyConditions}>
                  {atLeast8CharPassword ? <Check style={{ color: 'green', fontSize: '14px' }} /> : <Clear style={{ color: 'red', fontSize: '14px' }} />} <span >Must be at least 8 characters</span>
                </div>
                <div className={passwordStyles.passwordPolicyConditions}>
                  {allTypesCharsPassword ? <Check style={{ color: 'green', fontSize: '14px' }} /> : <Clear style={{ color: 'red', fontSize: '14px' }} />} <span >Must contain one upper case letter, one number and a special character</span>
                </div>
              </div>
              
            </form>

          </div>
        </div>
      </div>
    );
  }
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    fetchFinish: () => dispatch(fetchFinish()),
    fetchPending: () => dispatch(fetchPending()),
    logout: () => dispatch(logoutAction())
  };
};

export default connect(null, mapDispatchToProps)(withStyles(styles)(ChangePasswordContainer));